import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomer, deleteCustomer ,clearError,clearMessage} from "../redux/customerSlice";
import AddCustomer from "./AddCustomer";
import ConfirmationModal from "../BaseFiles/ConfirmationModel";
import { MdDelete } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";

export default function Customer() {
    const dispatch = useDispatch();
    const [deletedId, setDeletedId] = useState(null);
    const [visible, setVisible] = useState(false);
    const [addvisible, setAddVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const { customers, loading ,error,message} = useSelector((state) => state.customer);
  

      useEffect(() => {
        dispatch(getCustomer());

        if (error) {
          toast(error);
          setTimeout(() => {
            dispatch(clearError());
          }, 3000);
        }
        if (message) {
          toast(message);
          setTimeout(() => {
            dispatch(clearMessage());
          }, 3000);
        }
      }, [error, dispatch, message]);
   
    const handleDelete = (id) => {
      setDeletedId(id);
      setVisible(true);
    };
    const HandleAddCustomer = (id) => {
      setAddVisible(true);
    };
  
    const onClose = () => {
      setDeletedId(null);
      setVisible(false);
    };
  
    const onDelete = () => {
      dispatch(deleteCustomer(deletedId));
      onClose();
    };
  
    const filteredCustomer = customers?.filter((customer) =>
      customer.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  
  return (
    <>
    <ToastContainer/>
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold text-gray-900">Customer</h1>
          <p className="mt-2 text-sm text-gray-700">
            A list of all the Customer in your account including their name, phone and address.
          </p>
        </div>
        <div className=" flex  gap-x-4 mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
        <input
                value={searchQuery}
                onChange={(e)=>setSearchQuery(e.target.value)}
                placeholder="Search Customer"
                className="border p-2 rounded-full w-64"
              />
          <button
            type="button"
            onClick={() => HandleAddCustomer()}
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Add Customer
          </button>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    No.
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Name
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Phone
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Address
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredCustomer?.map((person,index) => (
                  <tr key={index}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                      {index+1}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.name}</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.phone}</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.address}</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <MdDelete onClick={()=>handleDelete(person.id)} className="text-red-500 text-2xl" />
                    </td>
                   
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    {visible && (
        <ConfirmationModal
          visible={visible}
          onConfirm={onDelete}
          message={"Are you sure? want to delete customer"}
          onCancel={onClose}
        />
      )}
      {addvisible && (
        <AddCustomer
          visible={addvisible}
          onCancel={()=>setAddVisible(false)}
        />
      )}
</>
  );
}
